import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { StoreService } from '../shared/store.service';
import * as PersonalizedContentSelectors from './personalized-content.selectors';

@Injectable({ providedIn: 'root' })
export class PersonalizedContentFacade {
  userPoints: Observable<string | null> = this.storeService.getState(
    PersonalizedContentSelectors.userPoints,
  );

  constructor(private storeService: StoreService) {}

  getPersonalizedContentWithKey = (key: string) => this[key] || of(undefined);
}
